import { render, staticRenderFns } from "./actCRUD.vue?vue&type=template&id=3f078dc4"
import script from "./actCRUD.vue?vue&type=script&lang=js"
export * from "./actCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports